const nameParticles = ['da', 'de', 'do', 'das', 'dos', 'e'];

export function formatUserInitials(name?: string | null): string {
  const words = (name ?? '')
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0 && !nameParticles.includes(word.toLowerCase()));

  if (words.length === 0) {
    return '';
  }

  const first = words[0];
  const last = words[words.length - 1];
  const initials = words.length === 1 ? first[0] : `${first[0]}${last[0]}`;

  return initials.toUpperCase();
}
